import React from "react";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { useApiStates } from "../../state/Store";
import ScenarioTable from "./ScenarioTable";

const ScenarioScreen: React.FC = () => {
    const api = useApiStates("scenarios");

    return (
        <SettingsPage title="Szenarien">

            <SettingsPageContent api={api}>

                <ScenarioTable scenarios={api.scenarios.value ?? []} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default ScenarioScreen;
